import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React base styles
import breakpoints from "assets/theme/base/breakpoints";
import AdditionlPoints from "../components/AdditionalPoints.js";
import { useAuth } from "context";
import "react-best-tabs/dist/index.css";
import Tabs, { Tab } from "react-best-tabs";
import "../../style.css";

import SimpleBackdrop from "components/MDLoader_Backdrop";
import SelectSmall from "components/MDSelector";
import MDButton from "components/MDButton";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";
import { RESTAURANT_LEVEL, CASHBACK_STATUS, POINTS_EARNED } from "../../../core/constant.js";
import PaginationControlled from "../../../core/utils/_pagination.js";
import orderHistoryData from "layouts/orderhistory/data/orderHistoryTableData";
import OrderHistoryMobile from "../components/OrderHistoryMobile.js";
import OrdersViaReceipts from "../components/OrdersViaReceipts.js";

function Header() {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [restaurantSearch, setRestaurantSearch] = useState("");
  const [tierFilter, setTierFilter] = useState("");
  const [cashbackFilter, setCashbackFilter] = useState("");
  const [pointEarnedFilter, setPointEarned] = useState("");
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const { miniSidenav, darkMode } = useAuth();
  const [showFilters, setShowFilters] = useState(false);
  const [orderDataForMobile, setOrderDataForMobile] = useState();

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      const newOrientation = window.innerWidth < breakpoints.values.sm ? "vertical" : "horizontal";
      if (newOrientation !== tabsOrientation) {
        setTabsOrientation(newOrientation);
      }
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, []);

  const { columns, rows } = orderHistoryData(
    restaurantSearch,
    tierFilter,
    pointEarnedFilter,
    cashbackFilter,
    setTotalPage,
    page,
    setLoader,
    setPage,
    setOrderDataForMobile
  );
  const clearFilter = () => {
    setTierFilter("");
    setCashbackFilter("");
    setCashbackFilter("");
    setRestaurantSearch("");
    setPointEarned("");
    setPage(1);
  };

  return (
    <MDBox position="relative" mb={6}>
      <Tabs
        activeTab={1}
        className=""
        ulClassName="text-muted dark-border setting-tabs"
        activityClassName="bg-primary"
      >
        <Tab
          title="Orders via receipts"
          className={`mr-3 mt-2 text-xs md:text-[15px] text-center font-medium `}
        >
          <div className="mt-4">
            <OrdersViaReceipts />
          </div>
        </Tab>

        <Tab title="Order history" className="mt-2 text-xs md:text-[15px] font-medium text-center ">
          <div className="mt-2">
            <MDBox pt={2}>
              <Grid container spacing={6}>
                <Grid item xs={12}>
                  <Card>
                    <MDBox
                      sx={{
                        display: "flex",
                        "@media (max-width:767px)": {
                          display: "none",
                        },
                      }}
                      pb={2}
                      px={1}
                      mt={3}
                    >
                      <Box
                        sx={{
                          width: 300,
                          maxWidth: "100%",
                        }}
                        px={2}
                      >
                        <TextField
                          fullWidth
                          label="Search restaurant"
                          id="restaurantSearch"
                          value={restaurantSearch}
                          onChange={(e) => {
                            setRestaurantSearch(e.target.value);
                          }}
                          sx={{
                            "@media (max-width:767px)": {
                              width: "150px",
                            },
                          }}
                        />
                      </Box>
                      <MDBox sx={{ display: "flex", gap: 2 }}>
                        <SelectSmall
                          placeholder={"Tier"}
                          menuItems={RESTAURANT_LEVEL}
                          filterValue={tierFilter}
                          setFilterValue={setTierFilter}
                        />
                        <SelectSmall
                          placeholder={"Cashback status"}
                          menuItems={CASHBACK_STATUS}
                          filterValue={cashbackFilter}
                          setFilterValue={setCashbackFilter}
                        />
                        <SelectSmall
                          placeholder={"Cashback Points"}
                          menuItems={POINTS_EARNED}
                          filterValue={pointEarnedFilter}
                          setFilterValue={setPointEarned}
                        />
                        <MDButton
                          variant="gradient"
                          color={"success"}
                          size="medium"
                          onClick={() => clearFilter()}
                          sx={{
                            textTransform: "none",
                            "@media (max-width:767px)": {
                              width: "max-content",
                            },
                          }}
                        >
                          Clear Filter
                        </MDButton>
                      </MDBox>
                    </MDBox>
                    <MDBox
                      sx={{
                        display: "none",
                        "@media (max-width:767px)": {
                          overflow: "auto",
                          display: "flex",
                          flexDirection: "column",
                        },
                      }}
                      pb={2}
                      px={1}
                      mt={3}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          borderBottom: !showFilters
                            ? darkMode
                              ? "1px solid white"
                              : "1px solid black"
                            : "",
                          paddingBottom: "10px",
                        }}
                      >
                        {miniSidenav && rows.length > 0 && (
                          <MDBox
                            sx={{
                              display: "flex",
                              justifyContent: "start",
                              "@media (max-width:767px)": {
                                height: "40px",
                              },
                            }}
                          >
                            <PaginationControlled
                              page={page}
                              setPage={setPage}
                              totalPage={totalPage}
                            />
                          </MDBox>
                        )}
                        <MDButton
                          variant="gradient"
                          color="success"
                          size="medium"
                          onClick={() => {
                            if (showFilters) {
                              clearFilter();
                            }
                            setShowFilters(!showFilters);
                          }}
                          sx={{
                            textTransform: "none",
                            mb: showFilters ? 2 : 0,
                            "@media (max-width:767px)": {
                              width: "max-content",
                              height: "40px",
                            },
                          }}
                        >
                          {showFilters ? "Clear Filter" : "Filter"}
                        </MDButton>
                      </Box>
                      {showFilters && (
                        <MDBox
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            "@media (max-width:767px)": {
                              flexDirection: "column",
                              gap: 1,
                            },
                          }}
                        >
                          <MDBox
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                              "@media (max-width:767px)": {
                                flexDirection: "column",
                                gap: 1,
                              },
                            }}
                          >
                            <SelectSmall
                              placeholder={"Tier"}
                              menuItems={RESTAURANT_LEVEL}
                              filterValue={tierFilter}
                              setFilterValue={setTierFilter}
                            />
                            <SelectSmall
                              placeholder={"Cashback status"}
                              menuItems={CASHBACK_STATUS}
                              filterValue={cashbackFilter}
                              setFilterValue={setCashbackFilter}
                            />
                            <SelectSmall
                              placeholder={"Cashback Points"}
                              menuItems={POINTS_EARNED}
                              filterValue={pointEarnedFilter}
                              setFilterValue={setPointEarned}
                            />
                          </MDBox>
                          <Box
                            sx={{
                              width: 300,
                              maxWidth: "100%",
                              px: 2,
                              "@media (max-width:767px)": {
                                width: "100%",
                                px: 0,
                              },
                            }}
                          >
                            <TextField
                              fullWidth
                              label="Search restaurant"
                              id="restaurantSearch"
                              value={restaurantSearch}
                              onChange={(e) => {
                                setRestaurantSearch(e.target.value);
                              }}
                              sx={{
                                "@media (max-width:767px)": {
                                  width: "100%",
                                },
                              }}
                            />
                          </Box>
                        </MDBox>
                      )}
                    </MDBox>
                    <MDBox>
                      {!loader ? (
                        <>
                          {miniSidenav ? (
                            <OrderHistoryMobile orderDataForMobile={orderDataForMobile} />
                          ) : (
                            <DataTable
                              table={{ columns, rows }}
                              isSorted={false}
                              entriesPerPage={false}
                              showTotalEntries={false}
                              noEndBorder
                            />
                          )}
                        </>
                      ) : (
                        <SimpleBackdrop />
                      )}
                    </MDBox>
                    {!miniSidenav && rows.length > 0 && (
                      <MDBox p={2} mt={1} sx={{ display: "flex", justifyContent: "center" }}>
                        <PaginationControlled page={page} setPage={setPage} totalPage={totalPage} />
                      </MDBox>
                    )}
                  </Card>
                </Grid>
              </Grid>
            </MDBox>
          </div>
        </Tab>

        <Tab
          title="Additional points"
          className={`mr-3 mt-2 text-xs text-center md:text-[15px] font-medium `}
        >
          <div className="mt-2">
            <AdditionlPoints />
          </div>
        </Tab>
      </Tabs>
    </MDBox>
  );
}

// Setting default props for the Header
Header.defaultProps = {
  children: "",
};

// Typechecking props for the Header
Header.propTypes = {
  children: PropTypes.node,
};

export default Header;
